import { render, staticRenderFns } from "./ClientItem.vue?vue&type=template&id=0b4b33dc&"
import script from "./ClientItem.vue?vue&type=script&lang=js&"
export * from "./ClientItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports